export default __webpack_public_path__ + "static/media/market_place.03e8644a.svg";